import React, { useState } from 'react';
import { QUERIES } from '../../api/queries';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Table, Spin, Row, Col, Popconfirm, Button, Icon, message, Modal, Form, Input } from 'antd';
import DOMPurify from 'dompurify'; //DOMPurify.sanitize()

const EmployeeTitleSettings = props => {

  const [employeeTitles, setEmployeeTitles] = useState(null);
  const [working, setWorking] = useState(false);
  const [selectedEmployeeTitle, setSelectedEmployeeTitle] = useState(null);
  const [inputModalVisible, setInputModalVisible] = useState(false);

  const [createEmployeeTitle] = useMutation(QUERIES.CREATE_EMPLOYEE_TITLE);
  const [updateEmployeeTitle] = useMutation(QUERIES.UPDATE_EMPLOYEE_TITLE);
  
  const { loading, error, refetch } = useQuery(QUERIES.EMPLOYEE_TITLES, {
    onCompleted: res => {
        setEmployeeTitles(res.employeeTitles);
    }
  });

  const employeeTitleModel = {
    name: '',
    code: '',
    isNew: true
  };

  const onMutationComplete = () => {
    message.success('Wijzigingen opgeslagen!');
    refetch()
      .then(res => {
        setEmployeeTitles(res.data.employeeTitles);
        setInputModalVisible(false);
        setWorking(false);
      })
  }

  const onMutationFailed = err => {
    message.error('Er ging iets mis');
    setInputModalVisible(false);
    setWorking(false);
    console.error(err);
  }

  const columns = [
    {
      title: 'Aanspreking',
      render: record => record.name,
      key: record => record.id+"Name",
    },
    {
      title: 'Code',
      render: record => record.code,
      key: record => record.id+"Code",
    },
    {
      render: record => {
        return(
            <span>
              <Button
              shape='circle'
              style={{ marginRight: '8px' }}
              onClick={() => {
                setSelectedEmployeeTitle(record);
                setInputModalVisible(true);
              }}
            ><Icon type="edit" /></Button>
            </span>
        )
      }
    }
  ];

  if (!loading && !error && !!employeeTitles && !working) {
    return (
      <div>
        <Button
          type='primary'
          onClick={() => {
            setSelectedEmployeeTitle({ ...employeeTitleModel });
            setInputModalVisible(true);
          }}><Icon type='plus' /> Nieuw
        </Button>

        <Row type='flex' justify='center'>
          <Table
            rowKey={record => record.id}
            style={{ width: '80vw', margin: 16 }}
            dataSource={employeeTitles}
            columns={columns}
          />
        </Row>

        <Modal
          visible={inputModalVisible}
          destroyOnClose={true}
          onOk={() => {
            setWorking(true);
            if (!!selectedEmployeeTitle.isNew) {
              const { isNew, ...rest } = selectedEmployeeTitle;
              createEmployeeTitle({ variables: { employeeTitle: rest } })
                .then(res => {
                  onMutationComplete();
                })
                .catch(err => {
                  onMutationFailed(err);
                })
            }
            else {
              const { __typename, ...rest } = selectedEmployeeTitle;
              updateEmployeeTitle({ variables: { employeeTitle: rest } })
                .then(res => {
                  onMutationComplete();
                })
                .catch(err => {
                  onMutationFailed(err);
                })
            }
          }}
          onCancel={() => {
            setInputModalVisible(false);
          }}
          cancelText={'Annuleren'}
        >
          {selectedEmployeeTitle && (
            <Form>
              <Form.Item required={true} label='Naam'>
                <Input
                  defaultValue={selectedEmployeeTitle.name}
                  onChange={e => {
                    const val = DOMPurify.sanitize(e.target.value);
                    setSelectedEmployeeTitle(old => {
                      return { ...old, name: val };
                    });
                  }} />
              </Form.Item>
              <Form.Item required={true} label='Code'>
                <Input
                  defaultValue={selectedEmployeeTitle.code}
                  onChange={e => {
                    const val = DOMPurify.sanitize(e.target.value);
                    // console.log(val);
                    setSelectedEmployeeTitle(old => {
                      return { ...old, code: val };
                    });
                  }} />
              </Form.Item>
            </Form>
          )}
        </Modal>
      </div>
    );
  }

  return (
    <div>
      <Row type='flex' justify='center'>
        <Col span={24}>
          <Spin size='large' />
        </Col>
      </Row>
    </div>
  );

};

export default EmployeeTitleSettings;